import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../../../../libs/shared/ui/src/components/buttons/button';
import {Icon} from '../../../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';
import {useLinkNavigation} from '../../../../../../components/common/navigation/useLinkNavigation';
import {buildContactsManagerSyncsUrl} from '../../../../../../helpers/contactsManagerHelpers';
import {useAppSelector} from '../../../../../../helpers/reduxHelpers';
import {CrmSyncSourcesEnum} from '../../../../../../models/api/crmSyncModel';
import {getIsUserGlobalAdmin} from '../../../../../../store/data/teammates/teammatesSelectors';
import {getHasMicrosoftDynamicsAccountSync} from '../../../../../../store/featureFlags/featureFlagsSelectors';

/*
 * Style.
 */

const StyledSectionDiv = styled.div`
  margin-bottom: 8px;
  color: ${(p) => p.theme.greys.shade60};
`;

const StyledAccountSyncTitleDiv = styled.div`
  font-size: ${fontSizes.large};
  color: ${(p) => p.theme.greys.shade80};
  margin-bottom: 4px;
`;

const StyledAccountSyncContentWrapperDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 12px;
  align-items: center;
`;

const StyledAccountSyncDescriptionDiv = styled.div`
  flex: 1;
`;

const StyledButtonContentWrapperDiv = styled.div`
  display: flex;
  gap: 4px;
`;

const StyledManageButtonDiv = styled.div`
  display: flex;
  height: 30px;
`;

/*
 * Component.
 */

export const SettingsAppsConfigureMicrosoftDynamics: FC = () => {
  const {navigateToLink} = useLinkNavigation();
  const isGlobalAdmin = useAppSelector(getIsUserGlobalAdmin);
  const hasMicrosoftDynamicsAccountSync = useAppSelector(getHasMicrosoftDynamicsAccountSync);

  const onNavigateToAccountSync = () => {
    navigateToLink(buildContactsManagerSyncsUrl(CrmSyncSourcesEnum.MICROSOFT_DYNAMICS));
  };

  return (
    <StyledSectionDiv>
      <StyledAccountSyncTitleDiv>
        <Trans id="settings-apps-configure-app-dialog-microsoft-dynamics-account-sync-title">
          Account sync
        </Trans>
      </StyledAccountSyncTitleDiv>
      <StyledAccountSyncContentWrapperDiv>
        <StyledAccountSyncDescriptionDiv>
          <Trans id="settings-apps-configure-app-dialog-microsoft-dynamics-account-sync-description">
            Syncing your accounts data will allow you to use customer information in rules, and will ensure
            your customer data is always up to date in Front.
          </Trans>
          {!hasMicrosoftDynamicsAccountSync && (
            <>
              {' '}
              <Trans id="settings-apps-configure-app-dialog-microsoft-dynamics-account-sync-description-not-enabled">
                This is currently a Beta release. Please contact your account manager to get access.
              </Trans>
            </>
          )}
        </StyledAccountSyncDescriptionDiv>
        <StyledManageButtonDiv>
          <Button
            onClick={onNavigateToAccountSync}
            isDisabled={!isGlobalAdmin || !hasMicrosoftDynamicsAccountSync}
          >
            <StyledButtonContentWrapperDiv>
              <Trans id="settings-apps-configure-app-dialog-microsoft-dynamics-account-sync-button">
                Manage
              </Trans>
              <Icon name="externalLinkSmall" />
            </StyledButtonContentWrapperDiv>
          </Button>
        </StyledManageButtonDiv>
      </StyledAccountSyncContentWrapperDiv>
    </StyledSectionDiv>
  );
};
